import { defineComponent as _defineComponent } from 'vue'
import { PropType, ref, watch } from 'vue';
import { TranslateResult } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'NewModalDialog',
  props: {
  title: { type: [String, Object] as PropType<string|TranslateResult>, required: false, default: '' },
  maxWidth: { type: String, required: false, default: '600' },
  persistent: { type: Boolean, required: false, default: false },
  cardClass: { type: String, required: false, default: null },
  cardHeight: { type: Number, required: false, default: null },
  cardMaxHeight: { type: String, required: false, default: null },
  scrollable: { type: Boolean, required: false, default: false },
  contentClass: { type: String, required: false, default: null },
  containerClass: { type: String, required: false, default: 'pa-md-5 pa-0' },
  fluid: { type: Boolean, required: false, default: false },
  fullscreen: { type: Boolean, required: false, default: false },
},
  emits: ['close'],
  setup(__props, { emit }) {

const props = __props;



const dialog = ref(true);
watch(dialog, () => {
  if (dialog.value === false) { emit('close'); }
});

const scrollContent = ref(null as null | HTMLElement);
const scrollToBottom = () => {
  const scrollDiv = scrollContent.value as HTMLElement;
  scrollDiv.scrollTop = scrollDiv.scrollHeight + 60;
};


return { __sfc: true,props, emit, dialog, scrollContent, scrollToBottom }
}

})